<script>
  import queryString from 'query-string';

  export let customClass;

  const parsed = (() => {
    try {
      return queryString.parse(window.location.search)
    } catch (exception) {
      return {}
    }
  })();

  const _customClass = ((parsed.customClass !== undefined && parsed.customClass !== 'undefined') ? ' ' + parsed?.customClass : '') + (customClass ? ' ' + customClass : '')
</script>

<div
  class={"loadingOverlay" + _customClass}
>
  <div class={"blobs" + _customClass}>
    <div class="blob-center"></div>
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="blob"></div>
  </div>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
    <defs>
      <filter id="goo">
        <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
        <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo" />
        <feBlend in="SourceGraphic" in2="goo" />
      </filter>
    </defs>
  </svg>
</div>

<style>
  .loadingOverlay {
    background-color: transparent;
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 50000;
  }
  .blobs {
    filter: url(#goo);
    width: 300px;
    height: 300px;
    overflow: hidden;
    border-radius: 70px;
    transform-style: preserve-3d;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .blobs .blob-center {
    transform-style: preserve-3d;
    position: absolute;
    background-color: #333;
    top: 50%;
    left: 50%;
    width: 30px;
    height: 30px;
    transform-origin: left top;
    transform: scale(0.9) translate(-50%, -50%);
    animation: blob-grow linear 3.4s infinite;
    border-radius: 50%;
    box-shadow: 0 0px 40px -5px #333;
  }

  .blob {
    position: absolute;
    background-color: #333;
    top: 50%;
    left: 50%;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    animation: blobs ease-out 3.4s infinite;
    transform: scale(0.9) translate(-50%, -50%);
    transform-origin: center top;
    opacity: 0;
  }

  .blob:nth-child(1) { animation-delay: 0.2s;}
  .blob:nth-child(2) { animation-delay: 0.4s;}
  .blob:nth-child(3) { animation-delay: 0.6s;}
  .blob:nth-child(4) { animation-delay: 0.8s;}
  .blob:nth-child(5) { animation-delay: 1s;}

  @keyframes blobs {
    0% { opacity: 0; transform: scale(0) translate(calc(-330px - 50%), -50%);}
    1% { opacity: 1;}	 
    35%, 65% { opacity: 1; transform: scale(0.9) translate(-50%, -50%);}
    99% { opacity: 1;}
    100% { opacity: 0; transform: scale(0) translate(calc(330px - 50%), -50%);}
  }

  @keyframes blob-grow {
    0%, 39% {	 transform: scale(0) translate(-50%, -50%);	}
    40%, 42% {	 transform: scale(1, 0.9) translate(-50%, -50%);}
    43%, 44% {	 transform: scale(1.2, 1.1) translate(-50%, -50%);}
    45%, 46% {	 transform: scale(1.3, 1.2) translate(-50%, -50%);}
    47%, 48% {	 transform: scale(1.4, 1.3) translate(-50%, -50%);}
    52% {	 transform: scale(1.5, 1.4) translate(-50%, -50%);}
    54% {	 transform: scale(1.7, 1.6) translate(-50%, -50%);}
    58% {	 transform: scale(1.8, 1.7) translate(-50%, -50%);}
    68%, 70% {	 transform: scale(1.7, 1.5) translate(-50%, -50%);}
    78% {	 transform: scale(1.6, 1.4) translate(-50%, -50%);}
    80%, 81% {	 transform: scale(1.5, 1.4) translate(-50%, -50%);}
    82%, 83% {	 transform: scale(1.4, 1.3) translate(-50%, -50%);}
    84%, 85% {	 transform: scale(1.3, 1.2) translate(-50%, -50%);}
    86%, 87% {	 transform: scale(1.2, 1.1) translate(-50%, -50%);}
    90%, 91% {	 transform: scale(1, 0.9) translate(-50%, -50%);}
    92%, 100% {	 transform: scale(0) translate(-50%, -50%);}
  }

  /*overlay*/
  .blobs.overlay .blob-center {
    background-color: #fff;
    box-shadow: 0 0px 40px -5px #fff;
  } 
  .blobs.overlay .blob {
    background-color: #fff;
  }

  /*Market*/
  .blobs.market .blob-center,
  .blobs.project-list .blob-center {
    background-color: #fff;
    box-shadow: 0 0px 20px -5px #000;
    z-index:1
  } 
  .blobs.market .blob,
  .blobs.project-list .blob {
    background-color: #fff;
    box-shadow: 0 0px 20px -5px #333;
    z-index:0;
  }

</style>
